import Vue from 'vue'
import VueRouter from 'vue-router'

// 加入我们
import Join from 'views/join/index.vue'
import Detail from 'views/join/detail.vue'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'Index',
    // component: Join,
    redirect: '/join',
    meta: {
      title: '首页',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // 加入我们
  {
    path: '/join',
    name: 'Join',
    component: Join,
    meta: {
      title: '加入我们',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // 加入我们 - 详情页
  {
    path: '/join/detail/:id?',
    component: Detail
  }
]

const router = new VueRouter({
  // 路由模式：hash(默认)，history模式
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
